module.exports = __webpack_public_path__ + "assets/images/tambor_fd42d7b193238d1d1aefa0e4b52aa91f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/cilindro/tambor.png
// module id = 190
// module chunks = 0